import React from 'react'
import SubTitle from '../../../ui/SubTitle'
import { Plus } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'
import ExtraItemBox from './ExtraItemBox'
import { Extra } from '../../../../types/modules/product.type'
import { PermissionGate } from '../../../admin/PermissionGate'
import { PermissionsKey } from '../../../../data/permissions'

type Props={
  extraItems:Extra[],
  storeId?:number
}

function ProductExtraItemList({extraItems,storeId}:Props) {
    const { productId } = useParams<{ productId: string }>();
    const numericProductId = productId ? parseInt(productId) : 0;
  return (
    <div className='w-[330px]'>
        <div className='flex justify-between items-center'>
            <SubTitle title='extra_items'/>
            <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
              <Link to={storeId ?`/admin/stores/${storeId}/products/${numericProductId}/extra-items?back=true` :`/store/products/${numericProductId}/extra-items?back=true`}>
                <Plus size={18} className=' text-Black'/>
            </Link>
            </PermissionGate>
        </div>
        <div>
          {
            extraItems.map(extra=>{
              return <ExtraItemBox key={extra.id+"extra"} extra={extra}/>
            })
          }
        </div>
    </div>
  )
}

export default ProductExtraItemList